/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';
import axios from 'axios';
import qs from 'qs';

// initial state
const state = {
  amount: null,
  invoiceNumber: null,
  currentSection: 'billingInfo',
  paymentInfo: {
    cardholderName: null,
    cardNumber: null,
    expDate: null,
    cvv: null,
  },
  loaders: {
    submitting: false,
  },
  // ...window.INITIAL_STATE.payInvoice,
};

// getters
const getters = {
  loaders: (state) => state.loaders,
  amount: (state) => state.amount,
  invoiceNumber: (state) => state.invoiceNumber,
  currentSection: (state) => state.currentSection,
  paymentInfo: (state) => state.paymentInfo,
  member_id: (state, getters, rootState) => rootState.main.member_id,
  user: (state, getters, rootState) => rootState.auth.user,
  paymentAmount: (state, getters) => {
    return parseInt(parseFloat(getters.amount)*100);
  },
  paymentPayload: (state, getters) => {
    return {
      paymentAmount: getters.paymentAmount,
      invoiceNumber: getters.invoiceNumber,
      user_id: getters.user.userInfo.id,
      user_email: getters.user.userInfo.email,
      user_name: getters.user.userInfo.name,
      member_id: getters.member_id,
      paymentInfo: getters.paymentInfo,
    };
  },
  paymentInfoComplete: (state) => {
    return state.paymentInfo.cardholderName !== '' && state.paymentInfo.cardholderName !== null &&
      state.paymentInfo.cardNumber !== '' && state.paymentInfo.cardNumber !== null &&
      state.paymentInfo.expDate !== '' && state.paymentInfo.expDate !== null &&
      state.paymentInfo.cvv !== '' && state.paymentInfo.cvv !== null;
  },
  formValid: (state, getters) => {
    return state.paymentAmount > 0 &&
      state.invoiceNumber !== '' && state.invoiceNumber !== null &&
      getters.paymentInfoComplete;
  },
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
  setObjectProperty({ commit }, payload) {
    commit('SET_OBJECT_PROPERTY', payload);
  },
  submitPayment({ commit, getters, dispatch }) {
    commit('TOGGLE_LOADING', { key: 'submitting', value: true });
    axios.post(`${CONFIG.get('BASE_URL')}/api/pay-invoice/submitPayment/`, qs.stringify(getters.paymentPayload))
      .then((response) => {
        commit('TOGGLE_LOADING', { key: 'submitting', value: false });
        commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cardNumber', value: null });
        commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'expDate', value: null });
        commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cvv', value: null });
        if (response.data === 'Transaction Successful') {
          dispatch('flash/addMessage', { text: 'Payment Received!' }, { root: true });
          commit('SET_PROPERTY', { key: 'currentSection', value: 'successMessage' });
        } else {
          dispatch('flash/addMessage', { text: 'Transaction Error', type: 'error' }, { root: true });
          commit('SET_PROPERTY', { key: 'currentSection', value: 'errorMessage' });
        }
      })
      .catch((error) => {
        commit('TOGGLE_LOADING', { key: 'submitting', value: false });
        console.error(error);
      });
  },

  resetForm({ commit }) {
    commit('SET_PROPERTY', { key: 'amount', value: null });
    commit('SET_PROPERTY', { key: 'invoiceNumber', value: null });
    commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cardholderName', value: null });
    commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cardNumber', value: null });
    commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'expDate', value: null });
    commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cvv', value: null });
    commit('SET_PROPERTY', { key: 'currentSection', value: 'billingInfo' });
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_OBJECT_PROPERTY(state, payload) {
    state[payload.object][payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  RESET_PRODUCT_FORM(state) {
    state.amount = null;
    state.invoiceNumber = null;
    state.currentSection = 'billingInfo';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
